document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper(".mySwiper", {
        direction: "horizontal",
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        grabCursor: true,
        preloadImages: false,
        lazy:{
            checkInView: true,
            loadPrevNext: true,
        },

        breakpoints: {

            100: {
                slidesPerView: 1,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: -16,
                spaceBetween: 16,
            },
            600: {
                slidesPerView: 1.2,
                slidesOffsetBefore: 28,
                slidesOffsetAfter: 28,
                spaceBetween: 28,
            },
            728: {
                slidesPerView: 1.4,
                slidesOffsetBefore: 28,
                slidesOffsetAfter: 28,
                spaceBetween: 28,
            },
            984: {
                slidesPerView: 'auto',
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                spaceBetween: 20,
            },
            1300: {
                slidesPerView: "auto",
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                spaceBetween: 24,
            }
        }
    });


    var swiper2 = new Swiper(".mySwiper-pricing", {
        direction: "horizontal",

        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true, // Test test test
        },

        grabCursor: true,
        //
        preloadImages: false,
        lazy: {
            checkInView: true,
            loadPrevNext: true,
        },

        //Responsive breakpoints
        breakpoints: {

            100: {
                slidesPerView: 1.2,
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                slideToClickedSlide: true,
                grabCursor: true,
            },
            425: {
                slidesPerView: "auto",
                spaceBetween: 16,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                slideToClickedSlide: true,
                grabCursor: true,
            },
            728: {
                slidesPerView: "auto",
                spaceBetween: 24,
                slidesOffsetBefore: 28,
                slidesOffsetAfter: 28,
                slideToClickedSlide: true,
                grabCursor: true,
            },
            1160: {
                slidesPerView: 3.14,
                spaceBetween: 24,
                slidesOffsetBefore: 28,
                slidesOffsetAfter: 28,
                slideToClickedSlide: false,
                grabCursor: false,
            },
            1436: {
                slidesPerView: 3.33,
                spaceBetween: 0,
                slidesOffsetBefore: 48,
                slidesOffsetAfter: 48,
                slideToClickedSlide: false,
                grabCursor: false,
            },
            1600: {
                slidesPerView: 3.25,
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slideToClickedSlide: false,
                grabCursor: false,
            },
            1700: {
                slidesPerView: 3.25,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                spaceBetween: 0,
                slideToClickedSlide: false,
                grabCursor: false,
            },
        }
    });
});

//# sourceMappingURL=swiperslider.js.map
